import Store from 'lightningjs-redux';
import {
  getAudioTracks,
  getSelectedAudioTrack,
  getSelectedSubtitlesTrack,
  getSubtitleTracks,
} from '../../../../logic/player/player.selectors';

const mapControllers = instance => [
  {
    selector: getAudioTracks,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.audioTracks = value;
    },
  },
  {
    selector: getSubtitleTracks,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.subtitleTracks = value;
    },
  },
  {
    selector: getSelectedAudioTrack,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.selectedAudioTrack = value;
    },
  },
  {
    selector: getSelectedSubtitlesTrack,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.selectedSubtitlesTrack = value;
    },
  },
];

export default Store.control(mapControllers);
